import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import styles from "./styles/footer-copyright.css.js";
import CopyrightContent from "components/copyright";

const FooterCopyright = ({ className, children, classes }) => (
  <div className={classes.dashboard_footer_copyright}>
    <div className={className}>
      <CopyrightContent />
    </div>
  </div>
);

FooterCopyright.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

export default withStyles(styles)(FooterCopyright);
